// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { MIABQuestionMetadata, MiabAiSuggestionResponse } from "../schema";

export function serialize_MiabAiSuggestionResponse(obj: MiabAiSuggestionResponse): string {
  const serialized = ((value: { questions: MIABQuestionMetadata[] }): unknown => {
    return {
      questions: ((value: MIABQuestionMetadata[]): unknown => {
        return value.map((value: { createdAt: DateTime<true> | null; question: string; title: string }): unknown => {
          return {
            createdAt: ((value: DateTime<true> | null): unknown => {
              if (value === null) {
                return null;
              }
              return value.toMillis();
            })(value["createdAt"]),
            question: ((value: string): unknown => {
              return value;
            })(value["question"]),
            title: ((value: string): unknown => {
              return value;
            })(value["title"]),
          };
        });
      })(value["questions"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_MiabAiSuggestionResponse(str: string): ParserResult<MiabAiSuggestionResponse> {
  return ((
    value: unknown,
  ): ParserResult<{
    questions: MIABQuestionMetadata[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/MiabAiSuggestionResponse]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/MiabAiSuggestionResponse]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "questions")) {
      return { success: false, reason: `[#/components/schemas/MiabAiSuggestionResponse/questions]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'questions'.` };
    }
    const parsed_questions = ((): ParserResult<MIABQuestionMetadata[]> => {
      return ((value: unknown): ParserResult<MIABQuestionMetadata[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/MiabAiSuggestionResponse/questions]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<MIABQuestionMetadata> => {
          return ((
            value: unknown,
          ): ParserResult<{
            createdAt: DateTime<true> | null;
            question: string;
            title: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/MIABQuestionMetadata]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/MIABQuestionMetadata]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "createdAt")) {
              return { success: false, reason: `[#/components/schemas/MIABQuestionMetadata/createdAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'createdAt'.` };
            }
            const parsed_createdAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/MIABQuestionMetadata/createdAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/MIABQuestionMetadata/createdAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["createdAt"]);
            })();
            if (!parsed_createdAt.success) {
              return { success: false, reason: parsed_createdAt.reason };
            }
            if (!hasProp(value, "question")) {
              return { success: false, reason: `[#/components/schemas/MIABQuestionMetadata/question]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'question'.` };
            }
            const parsed_question = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/MIABQuestionMetadata/question]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["question"]);
            })();
            if (!parsed_question.success) {
              return { success: false, reason: parsed_question.reason };
            }
            if (!hasProp(value, "title")) {
              return { success: false, reason: `[#/components/schemas/MIABQuestionMetadata/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
            }
            const parsed_title = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/MIABQuestionMetadata/title]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["title"]);
            })();
            if (!parsed_title.success) {
              return { success: false, reason: parsed_title.reason };
            }
            return { success: true, value: { createdAt: parsed_createdAt.value, question: parsed_question.value, title: parsed_title.value } };
          })(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/MiabAiSuggestionResponse/questions]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["questions"]);
    })();
    if (!parsed_questions.success) {
      return { success: false, reason: parsed_questions.reason };
    }
    return { success: true, value: { questions: parsed_questions.value } };
  })(parseJsonWithNumbersAsBigint(str));
}
